module.exports = __webpack_public_path__ + "static/media/AzureDE.3d950dc2.png";